import { NotificationVariants } from '@base-app';
import { useAddNotification } from '@modules/notifications/store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteUserModalResult } from '../types';
import useMutationDeleteUser from './useMutationDeleteUser';

const useDeleteUserModal = (): DeleteUserModalResult => {
  const addNotification = useAddNotification();
  const { t } = useTranslation(['common', 'teams']);
  const { mutate: deleteUserMutate } = useMutationDeleteUser(
    handleMutationDeleteUserSuccess,
    handleMutationDeleteUserError,
  );
  const [userToDelete, setUserToDelete] = useState<string | undefined>();

  const handleDelete = (userId: string): void => {
    setUserToDelete(userId);
  };

  const handleDeleteConfirm = async (userId: string): Promise<void> => {
    await deleteUserMutate(userId);
    setUserToDelete(undefined);
  };

  const handleDeleteCancel = (): void => {
    setUserToDelete(undefined);
  };

  function handleMutationDeleteUserSuccess(): void {
    addNotification({
      title: t('delete_success', {
        ns: 'teams',
      }),
      type: NotificationVariants.SUCCESS,
    });
  }

  function handleMutationDeleteUserError(): void {
    addNotification({
      title: t('delete_error', {
        ns: 'teams',
      }),
      type: NotificationVariants.ERROR,
    });
  }

  return {
    onCancel: handleDeleteCancel,
    onConfirm: handleDeleteConfirm,
    userToDelete,
    deleteUser: handleDelete,
  };
};

export default useDeleteUserModal;
